import React, { Component } from 'react';
import { connect } from "react-redux";
import { addLogin } from "../actions/loggedin_action";

class Logout extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        delete localStorage.token;   
        delete localStorage.profile;
        this.props.addLogin(false)
        window.location.href = "/";

    }

    render() {
        return (
            <p></p>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLogin: state.isLogin
    }
}

const mapDispatchToProps = {
    addLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout)